import { Theme } from '@abiglobalhealth/go-types'

import bgPatternSvg from '@/assets/background-pattern.svg?raw'
import defaultColors from '@/utils/theme/defaultColors.json'

const escapeSvgAttribute = (value: string) => value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

const themePatternColorRegex = /(fill|stroke)="(?:currentColor|#1A1A1A)"/g

const createPrimaryPatternSvg = (primary: string) =>
  bgPatternSvg.replace(themePatternColorRegex, (_, attribute: 'fill' | 'stroke') => {
    const escapedPrimary = escapeSvgAttribute(primary)

    return `${attribute}="${escapedPrimary}" ${attribute}-opacity="0.05"`
  })

export const getThemeBackgroundPattern = (theme?: Theme): string => {
  if (theme?.background?.pattern) return theme.background.pattern

  return `url("data:image/svg+xml,${encodeURIComponent(createPrimaryPatternSvg(theme?.primary || defaultColors.primary))}")`
}
